import React from 'react';
import { Modal, Button, Form, Tag } from 'antd';
import { REGISTRADO, EMITIDO, RECHAZADO, ANULADO } from '../../../common/types/guiaRemisionEstadoType';

export default class CdrModal extends React.Component {
    renderColor = (item) => {
        if (item.idGuiaRemisionEstado === REGISTRADO)
            return 'blue';
        if (item.idGuiaRemisionEstado === EMITIDO)
            return 'green';
        if (item.idGuiaRemisionEstado === RECHAZADO)
            return 'orange';
        if (item.idGuiaRemisionEstado === ANULADO)
            return 'red';
    };

    item = (label, value) => {
        return (
            <div style={{ width: '100%', display: 'inline-flex', marginBottom: 8, background: '#fafafa' }}>
                <div style={{ width: '170px', color: '#242424', padding: 6 }}>
                    {label}
                </div>
                <div style={{ width: 'calc(100% - 170px)', padding: 6 }}>
                    {value}
                </div>
            </div>
        );
    }

    render() {
        return (
            <Modal
                title={"CDR Sunat"}
                visible={this.props.visible}
                onCancel={this.props.onClose}
                style={{ top: 30 }}
                width={550}
                footer={[
                    <Button
                        key="1"
                        onClick={this.props.onClose}
                    >
                        Cancelar
                    </Button>,
                    <Button
                        key="2"
                        type="primary"
                        onClick={this.props.onDownloadXml}
                        loading={this.props.loadingXml}
                    >
                        Descargar XML
                    </Button>,
                    <Button
                        key="3"
                        type="primary"
                        onClick={this.props.onDownloadCdr}
                        loading={this.props.loadingXml}
                    >
                        Descargar CDR
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            {this.item("Tipo de Comprobante:", this.props.item.nombreTipoComprobante)}
                            {this.item("Número de Documento:", this.props.item.serieDocumento)}
                            {this.item("Fecha de Envio:", this.props.item.fechaStr)}
                            {this.item("Fecha de Respuesta:", this.props.item.fechaEmisionStr)}
                            {this.item("Estado:",
                                <div className="custom-options" >
                                    <Tag color={this.renderColor(this.props.item)}>{this.props.item.nombreGuiaRemisionEstado}</Tag>
                                </div>)}
                            {this.item("Respuesta Sunat:", this.props.item.respuestaSunat)}
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}